var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 8,
  y: 30,
  width: 24,
  height: 4.4,
  rx: 1.5,
  fill: "#d5dde2"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 9.2,
  y: 25.8,
  width: 21.6,
  height: 4.4,
  rx: 1.5,
  fill: "#eef1f5"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 10.4,
  y: 21.6,
  width: 19.2,
  height: 4.4,
  rx: 1.5,
  fill: "#d5dde2"
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(-9 19 16)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 9.5,
  y: 14,
  width: 19,
  height: 4.4,
  rx: 1.5,
  fill: "#eef1f5"
}), /*#__PURE__*/React.createElement("rect", {
  x: 9.5,
  y: 15.7,
  width: 19,
  height: 1,
  fill: "#9aa7b0"
}));

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 37.5,
  cy: 8.5,
  r: 6,
  fill: "#23967f"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m40.8 8.5a3.3 3.3 0 1 1-3.3-3.3",
  fill: "none",
  stroke: "#ffffff",
  strokeWidth: 1.5,
  strokeLinecap: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m37.3 3.5 3.2 1.7-3.2 1.7z",
  fill: "#ffffff"
});

function SvgRefillPigPads(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 45 45",
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefillPigPads);
export default __webpack_public_path__ + "static/media/refill-pig-pads.07266171411b94c192c998b6781f3ecb.svg";
export { ForwardRef as ReactComponent };